export default __webpack_public_path__ + "static/media/IconCheck.f578a601.svg";